import { Switch, Route } from 'react-router-dom';

import * as Pages from 'pages';
import { constants } from 'utils';

export default function Routes(): JSX.Element {
  return (
    <Switch>
      <Route exact path={constants.Routes.Home}>
        <Pages.Home />
      </Route>
      {/* <Route exact path={constants.Routes.Transaction}>
        <Pages.Transaction />
      </Route> */}
      <Route path={constants.Routes.Others}>
        <Pages.Home />
      </Route>
    </Switch>
  );
}
